export const elementsIds = {
  HEADER: "fixed-header",
  FOOTER: "fixed-footer",
  STICKY: "sticky-element",
};
